let runtimeConfig = null;

function resolveConfigEnv() {
  if (process.env.NODE_ENV === "production") {
    return "prod";
  }
  return "dev";
}

export async function loadRuntimeConfig() {
  const env = resolveConfigEnv();
  const base = process.env.BASE_URL || "/";
  const url = `${base}runtime-config.${env}.json`;
  const res = await fetch(url, { cache: "no-store" });
  if (!res.ok) {
    throw new Error(`无法加载运行时配置：${url}`);
  }
  runtimeConfig = await res.json();
  return runtimeConfig;
}

export function getRuntimeConfig() {
  if (!runtimeConfig) {
    throw new Error("运行时配置尚未加载，请先调用 loadRuntimeConfig()");
  }
  return runtimeConfig;
}

export function isRuntimeConfigLoaded() {
  return runtimeConfig != null;
}
